export const vueContext = {
  instance: null,
}

export function setVueContext(instance) {
  vueContext.instance = instance
}

export function getVueContext() {
  return vueContext.instance
}
